import { Injectable, SecurityContext, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * Sanitize untrusted HTML (CMS / API) before any trust bypass or [innerHTML] bind.
 * Never call bypassSecurityTrustHtml on raw CMS HTML.
 */
@Injectable({ providedIn: 'root' })
export class HtmlSanitizeService {
  private readonly sanitizer = inject(DomSanitizer);

  /** Strip dangerous markup; return a plain string safe for [innerHTML]. */
  cleanHtml(html: string | null | undefined): string {
    return this.sanitizer.sanitize(SecurityContext.HTML, html ?? '') ?? '';
  }

  /** Sanitize then mark as SafeHtml (for callers that already store SafeHtml). */
  toSafeHtml(html: string | null | undefined): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.cleanHtml(html));
  }
}
